const versionFromEnv = () => {
    const candidates = [
        process.env.NEXT_PUBLIC_ASSET_VERSION,
        process.env.ASSET_VERSION,
        process.env.NEXT_PUBLIC_COMMIT_HASH,
        process.env.COMMIT_HASH,
        process.env.BRANCH_NAME
    ];

    for (const value of candidates) {
        const trimmed = (value || '').trim();
        if (trimmed) {
            return trimmed;
        }
    }

    return '';
};

let cachedVersion: string | null = null;

export function getAssetVersion(): string {
    if (cachedVersion !== null) {
        return cachedVersion;
    }

    cachedVersion = versionFromEnv() || 'dev';
    return cachedVersion;
}

export function withAssetVersion(url: string | undefined | null): string {
    if (!url) {
        return '';
    }

    const version = getAssetVersion();
    if (!version) {
        return url;
    }

    const [base, hash] = url.split('#');
    const alreadyHasVer = /([?&])ver=/.test(base);
    if (alreadyHasVer) {
        return url;
    }

    const separator = base.includes('?') ? '&' : '?';
    const versioned = `${base}${separator}ver=${encodeURIComponent(version)}`;
    return hash ? `${versioned}#${hash}` : versioned;
}
